import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette }: Theme) => ({
    messageTop: {
      marginBottom: 15,
      paddingTop: 15,
      color: custom.grey[3],
    },
    messageBottom: {
      paddingTop: 15,
      color: custom.grey[2],
    },
  })
);
